import { render, staticRenderFns } from "./TickspeedRow.vue?vue&type=template&id=49844122&scoped=true&"
import script from "./TickspeedRow.vue?vue&type=script&lang=js&"
export * from "./TickspeedRow.vue?vue&type=script&lang=js&"
import style0 from "./TickspeedRow.vue?vue&type=style&index=0&id=49844122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49844122",
  null
  
)

export default component.exports